import { getDomain } from '../config';

const domain = getDomain();

export const BASENAME = '/design/tools-software/spice-live-model';
export const APP_NAME = 'SPICE Live Model Beta';

export const COOKIES = {
	POLICY_CONSENT: 'prt_policyConsent'
};

export const PAGE_TITLE = 'Product Recommendation Tool+';

export const SUPPORT_EMAIL = {
	label: 'web.tools@onsemi.com',
	url: 'web.tools@onsemi.com?subject=SPICE Live Model'
};

export const COMMUNITY_FORUM = {
	label: 'Community Forum',
	url: 'https://community.onsemi.com/s/topicanddiscussion'
};

export const URL = {
	ONSEMI: `https://www.${domain}`,
	PRT_PLUS: `https://www.${domain}/design/tools-software/product-recommendation-tools-plus`,
	PRODUCT_PAGE: `https://www.${domain}/PowerSolutions/product.do?id=`,
	DATASHEET: `https://www.${domain}/download/data-sheet/pdf/`,
	LEGACY_TOOLS: `https://www.${domain}/support/product-recommendation-tool`,
	DESIGN_TOOLS: `https://www.${domain}/design-tools/inputs?`,
	SALES_SUPPORT: `https://www.${domain}/support/sales`,
	TECHNICAL_SUPPORT_CENTER: 'https://onsemineworg.my.site.com/onsemisupportcenter/s/'
};
